import React from "react";

function Foot({ darkMode }) {
  return (
    <footer className={`foot ${darkMode ? "dark-theme" : ""}`} style={{ textAlign: "center", padding: "0.5rem 0" }}>
      <p style={{ margin: 0, fontSize: "0.9rem" }}>
        © 2025 All Rights Reserved Yashika Goyal
      </p>
    </footer>
  );
}

export default Foot;
